import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  html, body {
    overflow-x: hidden;
    width: 100%;
  }
 
  ::selection {
    background: var(--color-yellow-60);
  }
`;

export default GlobalStyle;
